import { create } from 'zustand';

/**
 * Avatar-creation state pushed from Unity. Balance comes from accountStore
 * (the web app fetches it via the native JWT); only the Tripo character cost
 * is pushed from Unity, since that is the authoritative value Unity charges.
 * Default 0 = the current "temporarily free" state; Unity overrides it on
 * panel open via the setTripoCharacterCost bridge message.
 */
interface AvatarCreateState {
  tripoCharacterCost: number;
  setTripoCharacterCost: (cost: number) => void;
}

export const useAvatarCreateStore = create<AvatarCreateState>((set) => ({
  tripoCharacterCost: 0,
  setTripoCharacterCost: (cost) => set({ tripoCharacterCost: cost }),
}));
